import React from 'react'

const SessionsIcon = props => (
  <svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g stroke="#000" fill="none" strokeWidth="1.5">
      <rect x="7" y="10" width="18" height="14" rx="3" />
      <path d="M11 24v2h10v-2" />
      <circle cx="16" cy="17" r="2.5" />
    </g>
  </svg>
)

export default SessionsIcon
